export default "__VITE_ASSET__82ff4da8__"